import React from "react";

import { Card, CardBody, Row, Col, Button } from "reactstrap";

import "../../styles/estilos.css";
import Page from "components/Page";
import ImgExitoso from "assets/img/icono-exitoso.png";
import ValoresCotizacion from "./ValoresCotizacion";
import ListadoProductos from "./ListaProductosCotizacion/ListadoProductos";
import { withRouter } from "react-router-dom";
import { infoIds } from "../../constants";

class Cotizacion5ConfirmacionFinal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      placa: "",
      validate: false,
      hasPlacaError: true,
      chasis: this.props.datosCotizacion.datosPlaca.chasis,
      datosFormulario: this.props.datosFVinculacion

    };
    this.metodo = this.metodo.bind(this);
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }


  metodo(e) {
    e.preventDefault();
    if (this.props.estado === "APROBADO") {
      this.props.history.replace({
        pathname: "/lista-cotizadores",
      });
      // this.props.history.replace({
      //   pathname: "/cotizacion",
      //   search: `?accion=nuevo`
      // });// Para ir a la pantalla de ramos y no permitirle regresar mediante el navegador
    }
  }

  onCompletarFVinculacon = (e) => {
    const { datosFormulario } = this.state;
    var url = window.btoa(datosFormulario.urlFormulario);
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get('id');
    var urlbackregreso = window.btoa(this.props.location.pathname + this.props.location.search)
    this.props.history.push({
      pathname: "/formulario-vinculacion",
      search: `?url=${url}&back=true&id=${idCarrito}&urlbackreturn=${urlbackregreso}`

    });
  }

  onEnviarForm = (e) => {
    this.props.enviarFormulario();
  }

  render() {
    const { validate, placa, chasis, datosFormulario } = this.state;
    const { datosCotizacion } = this.props;
    let {
      carDatosContratante,
      carDatosPagadorFacturacion,
      queUsuarioRealizoCotizacion,
      _id,
      TransaccionesPago,
    } = this.props.datosCarrito.productosCarrito;
    const urlpfdFirmado = this.props.datosCarrito.productosCarrito.urlpfdFirmado;
    const urlpdfSinFirma = this.props.datosCarrito.productosCarrito.urlpdfSinFirma;


    const obtenerTipoDocumento = (codigo) => {

      var documento = 'prueba'

      switch (codigo) {
        case "1":
          documento = "CÉDULA"
          break;
        case "2":
          documento = "RUC"
          break;
        case "3":
          documento = "PASAPORTE"
          break;

        default:
          documento = "12"
          break;
      }




      return documento


    }

 
    if (carDatosContratante === undefined || carDatosContratante === null) {
      carDatosContratante = {
        id: "",
        cliNombre1: "",
        cliApellido1: "",
        cliEmail: "",
        cliCelular: "",
        empCodigo: "",
        cliNombre2: "",
        cliApellido2: "",
        cliIdentificacion: "",
        cliTelefono: "",
        cliDireccion: "",
        cliFechaNacimiento: "",
        cliCiudad: "",
        cliProvincia: "",
        cliPais: "",
        cliCodGenero: "1",
        cliGenero: "",
        cliCodigoCiudad: "1",
        cliCodigoProvincia: "1",
        cliCodigoPais: "",
        cliCodigoTipoDocumento: infoIds.codigoCedulaStr,
        cliTipoDocumento: "",
        cliCodigoEstadoCivil: "",
        cliEstadoCivil: "",
        cliFechaEmisionPasaporte: null,
        cliFechaCaducidadPasaporte: null,
        cliFechaIngresoPais: null,
        cliPersoneria: "",
      };
    }

    if (
      carDatosPagadorFacturacion === undefined ||
      carDatosPagadorFacturacion === null
    ) {
      carDatosPagadorFacturacion = {
        id: "",
        cliNombre1: "",
        cliApellido1: "",
        cliEmail: "",
        cliCelular: "",
        empCodigo: "",
        cliNombre2: "",
        cliApellido2: "",
        cliIdentificacion: "",
        cliTelefono: "",
        cliDireccion: "",
        cliFechaNacimiento: "",
        cliCiudad: "",
        cliProvincia: "",
        cliPais: "",
        cliCodGenero: "1",
        cliGenero: "",
        cliCodigoCiudad: "1",
        cliCodigoProvincia: "1",
        cliCodigoPais: "",
        cliCodigoTipoDocumento: infoIds.codigoCedulaStr,
        cliTipoDocumento: "",
        cliCodigoEstadoCivil: "",
        cliEstadoCivil: "",
        cliFechaEmisionPasaporte: null,
        cliFechaCaducidadPasaporte: null,
        cliFechaIngresoPais: null,
        cliPersoneria: "",
      };
    } else {
      carDatosPagadorFacturacion = carDatosPagadorFacturacion[0];
    }
    let breadcrumbs = [{ name: "cotización de vehículos", active: true }];
    if (this.props.mostrarResumen === true) {
      breadcrumbs = [
        {
          name:
            this.props.datosUsuario.usu_tipo_usuario &&
              this.props.datosUsuario.usu_tipo_usuario !== "cliente"
              ? "Listado de Ventas"
              : "Listado de Compras",
          active: true,
          link: true,
          url: "/listado-compras",
        },
        { name: "cotización de vehículos", active: true },
      ];
    }
    return (
      <Page title="Cotización de vehículos" breadcrumbs={breadcrumbs}>
        <Row>
          {this.props.mostrarResumen === false && (
            <Col lg={8} md={12} sm={12} xs={12}>
              <div className="container-step">
                <div className="wrapper-step">
                  <div className="arrow-steps clearfix-step">
                    <div className="step">
                      {" "}
                      <span>1. Cotización</span>{" "}
                    </div>
                    <div className="step">
                      {" "}
                      <span>2. Resumen</span>{" "}
                    </div>
                    <div className="step current">
                      {" "}
                      <span>3. Confirmación</span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          )}
        </Row>
        <Row>
          <Col
            lg={8}
            md={12}
            sm={12}
            xs={12}
            className="detalle-cotizacion-box"
          >
            <Card className="flex-row">
              <CardBody>
                <Row>
                  <Col xs={12} lg={8} md={8} sm={4}>
                    <div style={{ padding: "1em" }}>
                      {this.props.mostrarResumen === false && (
                        <h2 style={{ color: "#001871" }}> FELICIDADES!</h2>
                      )}
                      {this.props.mostrarResumen === true && (
                        <h2 style={{ color: "#001871" }}>
                          {" "}
                          DETALLES DE LA{" "}
                          {this.props.datosUsuario.usu_tipo_usuario &&
                            this.props.datosUsuario.usu_tipo_usuario !== "cliente"
                            ? "VENTA"
                            : "COMPRA"}
                        </h2>
                      )}
                      <h5 style={{ textAlign: "justify" }}>
                        {" "}
                        {`Tu compra es la # ${this.props.datosCarrito.productosCarrito.carContadorCarrito ? this.props.datosCarrito.productosCarrito.carContadorCarrito : ''}`}
                        .
                      </h5>
                      {this.props.datosCarrito.productosCarrito
                        .TransaccionesPago &&
                        this.props.datosCarrito.productosCarrito
                          .TransaccionesPago.traPagoId && (
                          <h5 style={{ textAlign: "justify" }}>
                            {" "}
                            {`Referencia del Pago # ${this.props.datosCarrito.productosCarrito
                              .TransaccionesPago &&
                              this.props.datosCarrito.productosCarrito
                                .TransaccionesPago.traPagoId
                              ? this.props.datosCarrito.productosCarrito
                                .TransaccionesPago.traPagoId
                              : ""
                              }`}
                            .
                          </h5>
                        )}


                      {/*
                        <h5 style={{ textAlign: "justify" }}> {`Estado: ${TransaccionesPago && TransaccionesPago.traEstadoPlacetoPay ? TransaccionesPago.traEstadoPlacetoPay : ''}`}</h5>
                      */}

                      {this.props.datosCarrito.productosCarrito
                        .TransaccionesPago &&
                        this.props.datosCarrito.productosCarrito
                          .TransaccionesPago.traEstadoPago && (
                          <h5 style={{ textAlign: "justify" }}>
                            {" "}
                            {`Estado del Pago: ${this.props.datosCarrito.productosCarrito
                              .TransaccionesPago &&
                              this.props.datosCarrito.productosCarrito
                                .TransaccionesPago.traEstadoPago
                              ? this.props.datosCarrito.productosCarrito
                                .TransaccionesPago.traEstadoPago
                              : ""
                              }`}
                          </h5>
                        )}

                      {this.props.datosCarrito.productosCarrito
                        .queUsuarioRealizoCotizacion !== "broker" &&
                        this.props.mostrarResumen === false && (
                          <h6>
                            Por favor revisa tu correo electrónico{" "}
                            <strong>
                              ({`${carDatosContratante.cliEmail}`})
                            </strong>{" "}
                            para continuar el proceso de contratación de la
                            póliza. A continuación los detalles de tu compra.
                          </h6>
                        )}

                      <br></br>
                      {datosFormulario !== null && datosFormulario !== undefined && <h4 style={{ color: "#001871" }}>Detalle Formulario de Vinculacion</h4>}
                      {datosFormulario !== null && datosFormulario !== undefined && datosFormulario.Estado && <h5 style={{ textAlign: "justify" }}>Estado: {datosFormulario.Estado}</h5>}
                      {(datosFormulario !== null && datosFormulario !== undefined && datosFormulario.urlFormulario) && !(datosFormulario.CodEstado !== undefined && datosFormulario.CodEstado !== '' && datosFormulario.CodEstado === 'FVFL') &&
                        <div>
                          <Button
                            className="btn btn-purple"
                            onClick={this.onCompletarFVinculacon}
                            style={{ display: "block", margin: "0 0 0 auto", marginLeft: "0" }}
                          >
                            <i className="fa fa-pencil" aria-hidden="true" /> COMPLETAR FORMULARIO VINCULACIÓN
                          </Button>
                          <br></br>
                          <Button
                            className="btn btn-secondary"
                            onClick={this.onEnviarForm}
                            style={{ display: "block", margin: "0 0 0 auto", marginLeft: "0" }}
                          >
                            <i class="fa fa-paper-plane-o" aria-hidden="true" />{" "}
                            ENVIAR FORMULARIO AL CLIENTE
                          </Button>
                        </div>
                      }
                    </div>

                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>

                    {this.props.mostrarResumen === false && (
                      <img
                        src={ImgExitoso}
                        width="100px"
                        alt="imagen Resumen"
                      ></img>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div style={{ padding: "1em" }}>
                      {this.props.mostrarResumen &&
                        this.props.datosCarrito.productosCarrito &&
                        urlpdfSinFirma !== undefined && urlpdfSinFirma !== null && urlpdfSinFirma.length > 0 && (
                          <a
                            href={urlpdfSinFirma}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Button className="btn btn-primary btn btn-secondary">
                              <i
                                className="fa fa-cloud-download"
                                aria-hidden="true"
                              />{" "}
                              DESCARGAR PÓLIZA SIN FIRMA
                            </Button>&nbsp;
                          </a>
                        )}
                      {this.props.mostrarResumen === true &&
                        this.props.datosCarrito.productosCarrito &&
                        this.props.datosCarrito.productosCarrito
                          .urlpfdFirmado && (
                          <a
                            href={
                              this.props.datosCarrito.productosCarrito
                                .urlpfdFirmado
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Button className="btn btn-primary btn btn-secondary">
                              <i
                                className="fa fa-cloud-download"
                                aria-hidden="true"
                              />{" "}
                              DESCARGAR PÓLIZA CON FIRMA
                            </Button>

                          </a>
                        )}

                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {this.props.datosCarrito.productosCarrito.carProductos !==
              undefined &&
              this.props.datosCarrito.productosCarrito.carProductos.map(
                (carrito, index) => (
                  carrito.datosProducto ?
                    <ListadoProductos
                      key={"listaProd" + index}
                      datosCotizacion={carrito}
                      indice={index}
                      origen="final-cotizacion"
                    />
                    : null
                )
              )}

            <Card className="flex-row ">
              <CardBody>
                <Row>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <h4 style={{ fontWeight: "bold" }}>
                      Datos del Contratante
                    </h4>
                    <p />
                  </Col>
                </Row>

                <Row style={{ display: "none" }}>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Seleccione personería</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosContratante.cliNombre1} ${carDatosContratante.cliNombre2}`}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Tipo de documento</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>

                    {`${carDatosContratante.cliTipoDocumento ? carDatosContratante.cliTipoDocumento : obtenerTipoDocumento(carDatosContratante.codTipodocumento)} `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Número de Identificación</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosContratante.cliIdentificacion ? carDatosContratante.cliIdentificacion : carDatosContratante.identificacion} `}
                  </Col>
                </Row>

                {(carDatosContratante.cliNombres && carDatosContratante.codTipodocumento == '1') &&
           
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Nombres</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        {`${carDatosContratante.cliNombres ? carDatosContratante.cliNombres + " " + carDatosContratante.cliApellidos : null} `}
                      </Col>
                    </Row>

                }
                {(carDatosContratante.cliNombres && carDatosContratante.codTipodocumento == '2') &&
                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Razón Social</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      {`${carDatosContratante.cliNombres ? carDatosContratante.cliNombres : null} `}
                    </Col>
                  </Row>
                }
                {carDatosContratante.cliPersoneria !== undefined &&
                  carDatosContratante.cliPersoneria === "1" && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Nombres</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosContratante.cliNombre1} ${carDatosContratante.cliNombre2}`}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Apellidos</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosContratante.cliApellido1} ${carDatosContratante.cliApellido2}`}
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Estado Civil</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosContratante.cliEstadoCivil} `}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Género</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosContratante.cliGenero} `}
                        </Col>
                      </Row>
                    </div>
                  )}
                {carDatosContratante.cliPersoneria !== undefined &&
                  carDatosContratante.cliPersoneria === "2" && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Razón Social</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosContratante.cliRazonSocial}`}
                        </Col>
                      </Row>
                    </div>
                  )}

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Provincia</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`
                    ${carDatosContratante.cliProvincia ? 
                    carDatosContratante.cliProvincia :
                    carDatosContratante.provincia?
                     carDatosContratante.provincia.label :
                     ''
                     } `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Ciudad</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${
                      carDatosContratante.cliCiudad ? 
                      carDatosContratante.cliCiudad : 
                      carDatosContratante.ciudad ?
                      carDatosContratante.ciudad.label :
                      ''
                      } `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Fecha nacimiento</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosContratante.cliFechaNacimiento ? carDatosContratante.cliFechaNacimiento : carDatosContratante.fechaNacimiento} `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Correo Electrónico</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosContratante.cliEmail ? carDatosContratante.cliEmail : carDatosContratante.correo} `}
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Dirección</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosContratante.cliDireccion ? carDatosContratante.cliDireccion : carDatosContratante.direccion} `}
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Celular</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosContratante.cliCelular ? carDatosContratante.cliCelular : carDatosContratante.celular} `}
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <Card className="flex-row ">
              <CardBody>
                <Row>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    <h4 style={{ fontWeight: "bold" }}>Datos de Facturación</h4>
                    <p />
                  </Col>
                </Row>

                <Row style={{ display: "none" }}>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Seleccione personería</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosPagadorFacturacion.cliNombre1} ${carDatosPagadorFacturacion.cliNombre2}`}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Tipo de documento</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosPagadorFacturacion.cliTipoDocumento ? carDatosPagadorFacturacion.cliTipoDocumento : obtenerTipoDocumento(carDatosPagadorFacturacion.codTipodocumento)} `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Número de Identificación</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosPagadorFacturacion.cliIdentificacion ? carDatosPagadorFacturacion.cliIdentificacion : carDatosPagadorFacturacion.identificacion} `}
                  </Col>
                </Row>


                {(carDatosPagadorFacturacion.cliNombres && carDatosPagadorFacturacion.codTipodocumento == '1') &&
           
                    <Row>
                      <Col lg={4} md={4} sm={4} xs={12}>
                        <h5>Nombres</h5>
                      </Col>
                      <Col lg={8} md={8} sm={8} xs={12}>
                        {`${carDatosPagadorFacturacion.cliNombres ? carDatosPagadorFacturacion.cliNombres + " " + carDatosPagadorFacturacion.cliApellidos : null} `}
                      </Col>
                    </Row>

                }
                {(carDatosPagadorFacturacion.cliNombres && carDatosPagadorFacturacion.codTipodocumento == '2') &&
                  <Row>
                    <Col lg={4} md={4} sm={4} xs={12}>
                      <h5>Razón Social</h5>
                    </Col>
                    <Col lg={8} md={8} sm={8} xs={12}>
                      {`${carDatosPagadorFacturacion.cliNombres ? carDatosPagadorFacturacion.cliNombres : null} `}
                    </Col>
                  </Row>
                }

                {carDatosPagadorFacturacion.cliPersoneria !== undefined &&
                  carDatosPagadorFacturacion.cliPersoneria === "1" && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Nombres</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosPagadorFacturacion.cliNombre1} ${carDatosPagadorFacturacion.cliNombre2}`}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Apellidos</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosPagadorFacturacion.cliApellido1} ${carDatosPagadorFacturacion.cliApellido2}`}
                        </Col>
                      </Row>

                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Estado Civil</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosPagadorFacturacion.cliEstadoCivil} `}
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Género</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosPagadorFacturacion.cliGenero} `}
                        </Col>
                      </Row>
                    </div>
                  )}

                {carDatosPagadorFacturacion.cliPersoneria !== undefined &&
                  carDatosPagadorFacturacion.cliPersoneria === "2" && (
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                          <h5>Razón Social</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                          {`${carDatosPagadorFacturacion.cliRazonSocial}`}
                        </Col>
                      </Row>
                    </div>
                  )}

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Provincia</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${
                      carDatosPagadorFacturacion.cliProvincia ? 
                      carDatosPagadorFacturacion.cliProvincia : 
                      carDatosPagadorFacturacion.provincia ?
                      carDatosPagadorFacturacion.provincia.label :
                      ''
                      } `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Ciudad</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${
                      carDatosPagadorFacturacion.cliCiudad ? 
                      carDatosPagadorFacturacion.cliCiudad : 
                      carDatosPagadorFacturacion.ciudad ?
                      carDatosPagadorFacturacion.ciudad.label
                      :''
                      } `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Fecha nacimiento</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosPagadorFacturacion.cliFechaNacimiento ? carDatosPagadorFacturacion.cliFechaNacimiento : carDatosPagadorFacturacion.fechaNacimiento} `}
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Correo Electrónico</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosPagadorFacturacion.cliEmail ? carDatosPagadorFacturacion.cliEmail : carDatosPagadorFacturacion.correo} `}
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Dirección</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosPagadorFacturacion.cliDireccion ? carDatosPagadorFacturacion.cliDireccion : carDatosPagadorFacturacion.direccion} `}
                  </Col>
                </Row>
                <Row>
                  <Col lg={4} md={4} sm={4} xs={12}>
                    <h5>Celular</h5>
                  </Col>
                  <Col lg={8} md={8} sm={8} xs={12}>
                    {`${carDatosPagadorFacturacion.cliCelular ? carDatosPagadorFacturacion.cliCelular : carDatosPagadorFacturacion.celular} `}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col lg={4} md={12} sm={12} xs={12} className="detalle-impuestos-box">
            <Card className="flex-row div-flotante">
              {this.props.datosCarrito.productosCarrito.valorTotal !==
                undefined && (
                  <ValoresCotizacion
                    formEditado={false}
                    paso={"final-cotizacion"}
                    metodo={this.metodo}
                    valorTotal={
                      this.props.datosCarrito.productosCarrito.valorTotal
                    }
                  ></ValoresCotizacion>
                )}
            </Card>
          </Col>
        </Row>
      </Page>
    );
  }
}
export default withRouter(Cotizacion5ConfirmacionFinal);
